import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    name: "",
    user: null,
    userData: null,
    organisationData: null,
    groupsData: null,
    userPrivateData: null,
    notifications: null,
    friends: null,
    friendsData: null,
    acceptedPolicies: false
  },
  mutations: {
    updateUserData(state, { userData }) {
      Vue.set(state, "userData", userData);
    },
    updateUserPrivateData(state, { userPrivateData }) {
      Vue.set(state, "userPrivateData", userPrivateData);
    },
    updateUser(state, { user }) {
      Vue.set(state, "user", user);
    },
    updateOrganisationData(state, { organisationData }) {
      Vue.set(state, "organisationData", organisationData);
    },
    updateGroupsData(state, { groupsData }) {
      Vue.set(state, "groupsData", groupsData);
    },
    updateNotifications(state, { notifications }) {
      Vue.set(state, "notifications", notifications);
    },
    updateFriends(state, { friends }) {
      Vue.set(state, "friends", friends);
    },
    updateFriendsData(state, { friendsData }) {
      Vue.set(state, "friendsData", friendsData);
    },
    updateAcceptedPolicies(state, update) {
      Vue.set(state, "acceptedPolicies", update);
    }
  },
  getters: {
    userData: state => state.userData,
    userPrivateData: state => state.userPrivateData,
    organisationData: state => state.organisationData,
    groupsData: state => state.groupsData,
    notifications: state => state.notifications,
    user: state => state.user,
    friends: state => state.friends,
    friendsData: state => state.friendsData,
    acceptedPolicies: state => state.acceptedPolicies
  },
  actions: {}
});
